import axios from 'axios';

/**
 * Utility functions for URL preview functionality
 */
export const urlPreviewUtils = {
  // Helper function to strip HTML tags and get plain text
  stripHtml: (html) => {
    if (!html) return '';
    // Create a temporary div element to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  },

  detectAndPreviewUrls: async (content, existingPreviews = {}, setLinkPreviews, setLoadingPreview) => {
    // Handle both HTML (from React Quill) and plain text (from textarea)
    const text = content.includes('<') ? urlPreviewUtils.stripHtml(content) : content;

    // Improved regex to capture complete URLs including those at end of text
    const urlRegex = /(https?:\/\/[^\s\n\r]+)/g;
    const urls = text.match(urlRegex);

    if (urls) {
      // Filter out incomplete URLs and URLs we already have previews for
      const validUrls = urls.filter(url => {
        try {
          // Clean up the URL (remove trailing punctuation that might not be part of URL)
          const cleanUrl = url.replace(/[.,;:!?]+$/, '');
          new URL(cleanUrl); // Validate URL
          return !existingPreviews[cleanUrl];
        } catch (error) {
          return false;
        }
      });

      // Only show preview for the first valid URL found
      if (validUrls.length > 0) {// && Object.keys(existingPreviews).length === 0

        const firstUrl = validUrls[0].replace(/[.,;:!?]+$/, ''); // Clean the URL
        if (setLoadingPreview) {
          await urlPreviewUtils.fetchUrlPreview(firstUrl, setLinkPreviews, setLoadingPreview);
        }
      }
    }
  },

  fetchUrlPreview: async (url, setLinkPreviews, setLoadingPreview) => {
    try {
      if (setLoadingPreview) setLoadingPreview(true);

      try {
        // Try to fetch URL metadata using backend endpoint
        const response = await axios.post('/api/url-preview', { url });

        if (response.data.success) {
          setLinkPreviews([]);
          setLinkPreviews(prev => ({
            ...prev,
            [url]: response.data.preview
          }));
          return;
        }
      } catch (apiError) {
        console.error('API fetch failed, using fallback preview:', apiError.message);
      }

      // Fallback: Create a basic preview using URL analysis
      const urlObj = new URL(url);
      const fullDomain = urlObj.hostname;
      const domain = fullDomain.replace('www.', '');

      // Better title generation
      const domainParts = domain.split('.');
      const mainDomain = domainParts[0];
      const title = `${mainDomain.charAt(0).toUpperCase() + mainDomain.slice(1)} - Link Preview`;

      const fallbackPreview = {
        title: title,
        description: `Visit ${domain} for more information`,
        image: `https://www.google.com/s2/favicons?sz=64&domain=${fullDomain}`,
        url: url,
        domain: domain
      };

      setLinkPreviews(prev => ({
        ...prev,
        [url]: fallbackPreview
      }));
    } catch (error) {
      console.error('Failed to fetch URL preview:', error);

      // Even simpler fallback
      setLinkPreviews(prev => ({
        ...prev,
        [url]: {
          title: 'Link Preview',
          description: 'Click to visit this link',
          image: null,
          url: url
        }
      }));
    } finally {
      if (setLoadingPreview) setLoadingPreview(false);
    }
  },

  removeLinkPreview: (url, setLinkPreviews) => {
    return;
    setLinkPreviews(prev => {
      const updated = { ...prev };
      delete updated[url];
      return updated;
    });
  }
};